<template>
    <div class="flex flex-col gap-4 rounded-muval-2 bg-gray-50 p-4">
        <div class="flex items-baseline gap-2">
            <div class="text-base font-medium text-muval-gray-1">Price breakdown</div>
            <span class="text-xs text-muval-gray-2">{{ displayPricesExGst ? 'excludes GST' : 'includes GST' }}</span>
        </div>
        <div class="flex flex-col divide-y divide-gray-200">
            <div
                v-for="(item, idx) in breakdownItems"
                :key="idx"
                class="flex flex-col pb-3 pt-3 first:pt-0 last:pb-0"
            >
                <div class="flex items-baseline justify-between">
                    <div class="text-xs font-medium text-muval-gray-1">{{ item.label }}</div>
                    <div
                        v-if="item.unitCost"
                        class="text-right text-xs text-muval-gray-1"
                    >
                        {{ item.unitCost }}
                    </div>
                </div>

                <div
                    v-for="row in item.rows"
                    :key="row.label"
                    class="mt-3 flex items-baseline justify-between"
                >
                    <div class="text-xs text-muval-gray-2">{{ row.label }}</div>
                    <div
                        class="text-right text-xs"
                        :class="{ 'italic text-muval-gray-2': row.muted, 'text-muval-gray-1': !row.muted }"
                    >
                        {{ row.value }}
                    </div>
                </div>
            </div>
        </div>

        <div class="flex items-center justify-between border-t border-gray-200 pt-3">
            <div class="text-sm font-medium text-muval-gray-1">Due now</div>
            <div class="text-base font-semibold text-muval-gray-1">{{ dueNowTotal }}</div>
        </div>
    </div>
</template>

<script setup>
import { usePriceBreakdown } from '@/composables/usePriceBreakdown';

const props = defineProps({
    orderItemIds: {
        type: Array,
        required: false,
        default: () => [],
    },
});

const { breakdownItems, dueNowTotal, displayPricesExGst } = usePriceBreakdown({
    orderItemIds: props.orderItemIds,
});
</script>
